var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyhoonAsteriskEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m39.42 21.57-11.04-.94a8.7 8.7 0 0 0 0-1.47l11.04-.94a19.74 19.74 0 0 1 0 3.35Zm-4.5-14.22-8.48 7.14a8.53 8.53 0 0 0-1.03-1.03l7.13-8.48a19.6 19.6 0 0 1 2.37 2.37ZM21.67.48l-.94 11.04a8.65 8.65 0 0 0-1.48 0L18.32.48a19.74 19.74 0 0 1 3.36 0ZM7.46 4.98l7.13 8.48c-.37.31-.72.66-1.03 1.03L5.09 7.35a19.6 19.6 0 0 1 2.37-2.37ZM.58 18.22a19.75 19.75 0 0 0 0 3.35l11.04-.94a8.65 8.65 0 0 1 0-1.47L.58 18.22Zm4.5 14.22 8.48-7.13c.31.37.66.71 1.03 1.03L7.46 34.8a19.6 19.6 0 0 1-2.37-2.37Zm13.24 6.87.94-11.03a8.7 8.7 0 0 0 1.48 0l.94 11.03a19.74 19.74 0 0 1-3.36 0Zm14.22-4.5-7.13-8.47c.37-.32.72-.66 1.03-1.03l8.47 7.13a19.6 19.6 0 0 1-2.37 2.37Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyhoonAsteriskEmpty);
export default __webpack_public_path__ + "static/media/MoneyhoonAsteriskEmpty.d088f4d20dbebb3fe67283048ce77f7d.svg";
export { ForwardRef as ReactComponent };